import React from "react";
import { useViewport } from "@core/theme";
import { CheckboxList } from "components/molecules";
import "./style.scss";

import dataLayer, { reduceCheckboxValues } from "helper/dataLayer";
import { sendFilterItemToDy } from "@/utils/dynamicYield";

import { ACTIONS, useFilterProvider } from "../FilterProvider";

import {
  MANUFACTURERS,
  OPERATING_SYSTEMS,
  STORAGE,
  COLORS,
} from "../FilterProvider/products";

import ColorFilter from "./Color";

const SmartphoneFilter = () => {
  const {
    state: {
      facets: { operatingSystems, manufacturers, colors, storage },
      shownFacets,
    },
    dispatch,
  } = useFilterProvider();

  const viewport = useViewport();
  const sortedStorageByValue = storage.sort((a, b) =>
    a.value < b.value ? 1 : -1
  ); // used for ascending storage rendering

  const entries = [
    {
      key: "filterManufacturers",
      header: "Hersteller",
      facet: "manufacturers",
      open: true,
      content: (
        <CheckboxList
          list={manufacturers}
          limit={viewport.lessThan.md ? 3 : manufacturers.length}
          onChange={(filterGroup, clickedItem) => {
            dispatch({
              type: ACTIONS.UPDATE_FILTER_GROUP,
              payload: {
                filterGroup,
                name: MANUFACTURERS,
              },
            });
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Marke:${reduceCheckboxValues(filterGroup)}`,
            });
            // dynamic yield filter event
            sendFilterItemToDy(MANUFACTURERS, clickedItem?.value);
          }}
        />
      ),
    },
    {
      key: "filterOs",
      header: "Betriebssystem",
      facet: "operatingSystems",
      open: false,
      content: (
        <CheckboxList
          list={operatingSystems}
          onChange={(filterGroup, clickedItem) => {
            dispatch({
              type: ACTIONS.UPDATE_FILTER_GROUP,
              payload: {
                filterGroup,
                name: OPERATING_SYSTEMS,
              },
            });
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Betriebssystem:${reduceCheckboxValues(filterGroup)}`,
            });
            // dynamic yield filter event
            sendFilterItemToDy(OPERATING_SYSTEMS, clickedItem?.value);
          }}
        />
      ),
    },
    {
      key: "filterStorage",
      header: "Speicherkapazität",
      facet: "storage",
      open: false,
      content: (
        <CheckboxList
          list={sortedStorageByValue}
          onChange={(filterGroup, clickedItem) => {
            dispatch({
              type: ACTIONS.UPDATE_FILTER_GROUP,
              payload: {
                filterGroup,
                name: STORAGE,
              },
            });
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Speicherkapazität:${reduceCheckboxValues(
                filterGroup
              )}`,
            });
            // dynamic yield filter event
            sendFilterItemToDy(STORAGE, clickedItem?.value);
          }}
        />
      ),
    },
    {
      key: "filterColor",
      header: "Farbe",
      facet: "colors",
      open: false,
      content: (
        <ColorFilter
          colors={colors}
          onChange={(_, filterGroup, clickedItem) => {
            dispatch({
              type: ACTIONS.UPDATE_FILTER_GROUP,
              payload: {
                filterGroup,
                name: COLORS,
              },
            });
            dataLayer({
              eventAction: "click",
              eventCategory: "Filter",
              eventLabel: `Farbe:${reduceCheckboxValues(filterGroup)}`,
            });
            // dynamic yield filter event
            sendFilterItemToDy(COLORS, clickedItem?.value);
          }}
        />
      ),
    },
  ].filter((entry) => shownFacets[entry.facet]);

  return (
    <div className="msd-filter-details__wrapper">
      {entries.map((entry) => (
        <details
          className="msd-filter-details"
          key={entry.key}
          open={entry.open}
        >
          <summary className="msd-filter-details__head">
            <span className="title">{entry.header}</span>
            <span className="arrow"></span>
          </summary>
          {entry.content}
        </details>
      ))}
    </div>
  );
};

export default SmartphoneFilter;
